<template>
    <HeaderComponent/>
    <section class="w-full relative flex items-center justify-center h-[450px] py-[50px] pt-[130px]">
        <div class="absolute top-0 left-0 w-full h-full overflow-hidden">
            <img src="../assets/images/photo_about2.avif" alt="" class="w-full h-full absolute object-cover object-center">
            <div class="degradeB"></div>
        </div>
        <div class="container lg:max-w-[1200px] flex md:flex-row flex-col w-full justify-center items-center relative px-[20px]">
            <div class="w-full md:flex-row flex-col flex items-center justify-center max-w-[900px] relative">
                <h1 class="lg:text-[45px] lg:w-[600px] md:w-[380px] w-full text-center md:text-left md:text-[30px] text-3xl font-bold text-white">
                    Contactez-nous
                </h1>
                <div class="md:pl-[40px] w-full md:border-l-[1px] pt-[40px] border-t-[1px] md:border-t-0 border-white md:ml-[40px] mt-[40px] md:mt-0 md:pt-0 flex flex-col">
                    <p class="text-white text-center md:text-left text-xl font-semibold mb-[20px]">
                        Besoin d’assistance ou d’information ?
                    </p>
                    <span class="text-gray-200 text-center md:text-left text-sm">
                        Notre équipe vous répond dans les plus brefs délais. Remplissez le formulaire ou contactez-nous directement.
                    </span>
                </div>
            </div>
        </div>
    </section>
    <section class="w-full relative flex items-center justify-center py-[50px]">
        <div class="container lg:max-w-[1200px] w-full px-[20px] relative flex md:flex-row flex-col items-start justify-center">
            <div class="md:w-[40%] w-full flex flex-col items-start justify-start mb-[30px] md:mb-0">
                <h2 class="text-sm font-bold uppercase text-[#D4AF37] mb-[10px]">
                    Restons en contact
                </h2>
                <p class="text-[35px] font-bold text-gray-800 mb-[20px]">
                    Comment Pouvons Nous vous aider ?
                </p>
                <span class="text-gray-600 max-w-[350px] text-sm">
                    Utilisez le formulaire de contact ou les coordonnées ci-dessous pour nous joindre facilement.
                </span>
                <div class="mt-[30px]">
                    <div class="flex items-center justify-start my-[20px]">
                        <div class="w-[48px] h-[48px] rounded-[50%] bg-[#D4AF37]  text-white flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><!-- Icon from Solar by 480 Design - https://creativecommons.org/licenses/by/4.0/ --><path fill="currentColor" fill-rule="evenodd" d="M15 2h2c1.886 0 2.828 0 3.414.586S21 4.114 21 6v15.25h1a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h1V9c0-1.886 0-2.828.586-3.414S5.114 5 7 5h4c1.886 0 2.828 0 3.414.586S15 7.114 15 9v12.25h1.5V8.91c0-.865 0-1.659-.087-2.304c-.095-.711-.32-1.463-.938-2.08c-.618-.619-1.37-.844-2.08-.94c-.637-.085-1.418-.086-2.269-.086c.084-.387.225-.68.46-.914C12.172 2 13.114 2 15 2M5.25 8A.75.75 0 0 1 6 7.25h6a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 8m0 3a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75M9 18.25a.75.75 0 0 1 .75.75v2.25h-1.5V19a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/></svg>
                        </div>
                        <div class="ml-[20px]">
                            <h3 class="text-gray-800 font-bold text-lg">Localisation</h3>
                            <p class="text-gray-600 text-sm">Cotonou Street 431</p>

                        </div>
                    </div>
                    <div class="flex items-center justify-start my-[20px]">
                        <div class="w-[48px] h-[48px] rounded-[50%] bg-[#D4AF37]  text-white flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><!-- Icon from Myna UI Icons by Praveen Juge - https://github.com/praveenjuge/mynaui-icons/blob/main/LICENSE --><path fill="currentColor" d="M9.004 3.416C8.432 2.606 7.64 2.241 6.8 2.25c-.797.008-1.573.349-2.221.803A6.2 6.2 0 0 0 2.92 4.79c-.41.649-.706 1.416-.666 2.165c.193 3.603 2.22 7.453 5.067 10.302c2.845 2.846 6.644 4.824 10.48 4.446c.752-.074 1.463-.457 2.044-.945a5.8 5.8 0 0 0 1.443-1.84c.34-.692.543-1.49.431-2.267c-.116-.81-.569-1.534-1.402-2.014a16 16 0 0 1-.512-.31c-.15-.093-.31-.194-.504-.31a7.5 7.5 0 0 0-1.249-.618c-.447-.163-.958-.27-1.49-.197c-.551.076-1.063.336-1.506.802c-.341.36-.843.472-1.549.268c-.718-.208-1.526-.724-2.228-1.422c-.702-.696-1.233-1.51-1.46-2.245c-.224-.728-.125-1.263.225-1.632c.473-.498.725-1.052.778-1.638c.052-.57-.09-1.106-.293-1.574c-.304-.699-.82-1.394-1.224-1.936a22 22 0 0 1-.3-.41"/></svg>
                        </div>
                        <div class="ml-[20px]">
                            <h3 class="text-gray-800 font-bold text-lg">Téléphone</h3>
                            <p class="text-gray-600 text-sm">+229 01 90179456/56581203</p>

                        </div>
                    </div>
                    <div class="flex items-center justify-start my-[20px]">
                        <div class="w-[48px] h-[48px] rounded-[50%] bg-[#D4AF37]  text-white flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><!-- Icon from Iconoir by Luca Burgio - https://github.com/iconoir-icons/iconoir/blob/main/LICENSE --><path fill="currentColor" fill-rule="evenodd" d="M4 4.25A2.75 2.75 0 0 0 1.25 7v10A2.75 2.75 0 0 0 4 19.75h16A2.75 2.75 0 0 0 22.75 17V7A2.75 2.75 0 0 0 20 4.25zm3.43 4.136a.75.75 0 0 0-.86 1.228l5 3.5a.75.75 0 0 0 .86 0l5-3.5a.75.75 0 1 0-.86-1.228L12 11.585z" clip-rule="evenodd"/></svg>
                        </div>
                        <div class="ml-[20px]">
                            <h3 class="text-gray-800 font-bold text-lg">E-mail</h3>
                            <p class="text-gray-600 text-sm">support@mohimmo.com</p>

                        </div>
                    </div>

                </div>
            </div>
            <div class="md:w-[60%] w-full relative flex flex-col items-center justify-center">
                <form @submit.prevent="submitForm" class="w-full bg-gray-100 md:p-[30px] p-[15px] rounded-[10px]">
                    <!-- Champs du formulaire -->
                    <div class="w-full flex md:flex-row flex-col items-start justify-between relative">
                      <div class="md:w-[48%] w-full my-[15px]">
                        <label for="firstName" class="block text-gray-700 text-sm font-bold mb-[5px]">Prénom</label>
                        <input 
                          v-model="formData.prenoms" 
                          type="text" 
                          id="firstName" 
                          class="w-full p-[10px] border border-gray-300 rounded-[5px] focus:outline-none focus:border-[#D4AF37]" 
                          required
                        >
                      </div>
                      <div class="md:w-[48%] w-full my-[15px]">
                        <label for="lastName" class="block text-gray-700 text-sm font-bold mb-[5px]">Nom de famille</label>
                        <input 
                          v-model="formData.nom" 
                          type="text" 
                          id="lastName" 
                          class="w-full p-[10px] border border-gray-300 rounded-[5px] focus:outline-none focus:border-[#D4AF37]" 
                          required
                        >
                      </div>
                    </div>

                    <div class="w-full flex md:flex-row flex-col items-start justify-between relative">
                      <div class="md:w-[48%] w-full my-[15px]">
                        <label for="email" class="block text-gray-700 text-sm font-bold mb-[5px]">E-mail</label>
                        <input 
                          v-model="formData.email" 
                          type="email" 
                          id="email" 
                          class="w-full p-[10px] border border-gray-300 rounded-[5px] focus:outline-none focus:border-[#D4AF37]" 
                          required
                        >
                      </div>
                      <div class="md:w-[48%] w-full my-[15px]">
                        <label for="phone" class="block text-gray-700 text-sm font-bold mb-[5px]">Téléphone</label>
                        <input 
                          v-model="formData.phone" 
                          type="text" 
                          id="phone" 
                          class="w-full p-[10px] border border-gray-300 rounded-[5px] focus:outline-none focus:border-[#D4AF37]" 
                          required
                        >
                      </div>
                    </div>

                    <div class="mb-[20px]">
                      <label for="message" class="block text-gray-700 text-sm font-bold mb-[5px]">Message</label>
                      <textarea 
                        v-model="formData.message" 
                        id="message" 
                        rows="4" 
                        class="w-full p-[10px] border border-gray-300 rounded-[5px] resize-none focus:outline-none focus:border-[#D4AF37]" 
                        required
                      ></textarea>
                    </div>

                    <!-- Bouton de soumission avec état de chargement -->
                    <button 
                      type="submit" 
                      :disabled="isSubmitting"
                      class="w-auto bg-[#D4AF37] hover:bg-[#b38a2c] text-white font-bold py-[10px] px-[15px] rounded focus:outline-none duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <span v-if="!isSubmitting">Envoyer</span>
                      <span v-else class="flex items-center justify-center gap-2">
                        <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Envoi en cours...
                      </span>
                    </button>

                    <!-- Messages de feedback -->
                    <div v-if="feedbackMessage" class="mt-4 p-3 rounded" :class="{
                      'bg-green-100 text-green-700': feedbackType === 'success',
                      'bg-red-100 text-red-700': feedbackType === 'error'
                    }">
                      <div class="flex items-center">
                        <svg v-if="feedbackType === 'success'" class="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                        </svg>
                        <svg v-else class="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                        </svg>
                        {{ feedbackMessage }}
                      </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
    <section class="py-[50px] flex flex-col justify-center items-center w-full relative">
        <h2 class="lg:text-[35px] text-3xl font-bold text-center px-[20px] w-full capitalize text-[#D4AF37]">Foire aux questions</h2>
        <p class="text-gray-600 max-w-[700px] px-[20px] text-center mb-[30px]">Trouvez rapidement des réponses aux questions les plus fréquentes.</p>
        <div class="container px-[20px] lg:max-w-[1200px] w-full relative flex md:flex-row flex-col items-center justify-center">
            <div class="w-full flex flex-col duration-300 max-w-[900px] justify-center items-center relative">
                <div
                v-for="(item, index) in faqItems"
                :key="index"
                class="rounded-[5px] my-[5px] border w-full shadow-9xl overflow-hidden bg-white"
                >
                    <div
                    class="flex justify-between items-center px-4 py-3 cursor-pointer"
                    :class="{ 'bg-gray-100': item.isOpen }"
                    @click="toggleFAQ(index)"
                    >   
                        <div class="w-[30px] h-[30px] min-w-[30px] rounded-[50%] bg-gray-100 text-gray-600 flex justify-center items-center relative overflow-hidden">
                            {{index + 1}}
                        </div>
                        <h3 class="text-base font-semibold text-left w-full mx-[10px] text-gray-600"
                        :class="{ 'text-gray-800': item.isOpen }">
                            {{ item.question }}
                        </h3>
                        <div class="text-gray-500 duration-200"
                        :class="{ 'text-gray-800': item.isOpen }">
                            <span v-if="item.isOpen">−</span>
                            <span v-else>+</span>
                        </div>
                    </div>
                    <div
                    v-if="item.isOpen"
                    class="px-4 py-3 text-gray-600 text-sm overflow-hidden transition-all duration-300"
                    >
                        {{ item.answer }}
                    </div>
                </div>
            </div>
        </div>
    </section>

    <FooterComponent/>
</template>

<script setup>
import HeaderComponent from '@/components/HeaderComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import { ref } from 'vue';
import apiClient from '@/services/api';

const faqItems = ref([
  {
    question: "Quels types de biens propose MOH.IMMO ?",
    answer: "Moh.Immo propose une sélection haut de gamme d’appartements meublés et équipés, principalement en location courte et moyenne durée. Chaque bien est rigoureusement sélectionné pour offrir confort, élégance et localisation idéale.",
    isOpen: true,
  },
  {
    question: "Comment réserver un appartement ?",
    answer: "Vous pouvez réserver directement depuis notre site via le formulaire de réservation ou en nous contactant par téléphone ou WhatsApp. Une fois la disponibilité confirmée, un acompte vous sera demandé pour valider la réservation.",
    isOpen: false,
  },
  {
    question: "Quels sont les documents nécessaires pour louer un appartement ?",
    answer: "Pour toute location, il vous sera demandé une pièce d’identité valide (passeport, carte d’identité ou permis de conduire). Pour les séjours prolongés, des justificatifs supplémentaires peuvent être requis.",
    isOpen: false,
  },
  {
    question: "Les appartements sont-ils entièrement équipés ?",
    answer: "Oui. Tous nos appartements sont livrés prêts à vivre, avec électroménagers, linge de maison, vaisselle, Wi-Fi, et parfois des services additionnels comme le ménage ou un service de conciergerie.",
    isOpen: false,
  },
  {
    question: "Y a-t-il un dépôt de garantie ?",
    answer: "Oui, un dépôt de garantie est exigé avant l’entrée dans les lieux. Son montant varie selon le bien loué. Il est intégralement remboursé après vérification de l’appartement, dans un délai maximum de 72h après votre départ.",
    isOpen: false,
  },
  {
    question: "Quelle est la durée minimale de location ?",
    answer: "La durée minimale est généralement de 2 à 3 nuits, mais certains appartements peuvent être loués pour une seule nuit, selon les disponibilités et les périodes.",
    isOpen: false,
  },
  {
    question: "Puis-je visiter l’appartement avant de réserver ?",
    answer: "Nous offrons des visites virtuelles et, dans certains cas, des visites physiques sur rendez-vous. Cela vous permet de mieux apprécier la qualité de nos biens avant de confirmer votre choix.",
    isOpen: false,
  },
  {
    question: "Quels services sont inclus dans la location ?",
    answer: "La plupart de nos biens incluent l’eau, l’électricité, l’accès Internet et l’entretien ponctuel. Certains appartements incluent également le ménage régulier, un service de sécurité 24h/24 ou encore des équipements premium comme un jacuzzi ou une terrasse privée.",
    isOpen: false,
  },
  {
    question: "Puis-je annuler une réservation ?",
    answer: "Oui. Nos conditions d’annulation varient selon le bien et la période de réservation. En général, une annulation jusqu’à 48h avant la date d’arrivée permet un remboursement partiel ou complet. Les détails seront précisés dans votre contrat de location.",
    isOpen: false,
  },
  {
    question: "MOH.IMMO peut-il gérer mon bien en location ?",
    answer: "Absolument. Si vous êtes propriétaire d’un appartement et souhaitez le rentabiliser en toute tranquillité, notre service de gestion locative clé en main s’occupe de tout : photos professionnelles, diffusion, réservations, entretien, relation client, etc.",
    isOpen: false,
  },
  {
    question: "Comment contacter le service client de Moh.Immo ?",
    answer: "Notre équipe est disponible par téléphone, WhatsApp, e-mail ou via le formulaire de contact sur notre site. Nous nous engageons à répondre dans les plus brefs délais pour toute question ou assistance.",
    isOpen: false,
  },
]);

const toggleFAQ = (index) => {
  faqItems.value[index].isOpen = !faqItems.value[index].isOpen;
};

const formData = ref({
  prenoms: '',
  nom: '',
  email: '',
  phone: '',
  message: ''
});

const isSubmitting = ref(false);
const feedbackMessage = ref('');
const feedbackType = ref('');

const submitForm = async () => {
  isSubmitting.value = true;
  feedbackMessage.value = '';
  feedbackType.value = '';

  try {
    const response = await apiClient.post('/messages/send', formData.value);
    
    // Réinitialiser le formulaire après succès
    formData.value = {
      prenoms: '',
      nom: '',
      email: '',
      phone: '',
      message: ''
    };
    
    feedbackType.value = 'success';
    feedbackMessage.value = 'Votre message a été envoyé avec succès !';
  } catch (error) {
    feedbackType.value = 'error';
    
    if (error.response) {
      // Erreur du serveur avec réponse
      if (error.response.data.message) {
        feedbackMessage.value = error.response.data.message;
      } else {
        feedbackMessage.value = 'Une erreur est survenue lors de l\'envoi du message.';
      }
    } else if (error.request) {
      // Pas de réponse du serveur
      feedbackMessage.value = 'Impossible de se connecter au serveur. Vérifiez votre connexion internet.';
    } else {
      // Erreur de configuration
      feedbackMessage.value = 'Une erreur est survenue lors de la configuration de la requête.';
    }
  } finally {
    isSubmitting.value = false;
    
    // Effacer le message après 5 secondes
    if (feedbackMessage.value) {
      setTimeout(() => {
        feedbackMessage.value = '';
        feedbackType.value = '';
      }, 5000);
    }
  }
};
</script>

<style scoped>
/* Animation pour le bouton */
button {
  transition: background-color 0.2s, opacity 0.2s;
}

/* Animation pour les messages */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.degradeB {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7));
  pointer-events: none;
}
</style>
